import { atom, useAtom } from "jotai";

const accountCrowdModalVisible = atom(false);

export const useShowAccountCrowdModal = () => {
  const [visibleRemainderCountModal, setVisibleRemainderCountModal] = useAtom(accountCrowdModalVisible);

  return { visibleRemainderCountModal, setVisibleRemainderCountModal };
};
